/**
 * Node.js 总入口
 * 在 app/src/index.node.ts 基础上注册所有子模块
 *
 * webpack alias 会将 @cloudbase/app 解析到 packages/app 源码目录
 */
// @ts-ignore - webpack alias resolves this
import cloudbase from '@cloudbase/app'


import { registerAuth } from '@cloudbase/auth'
import { registerFunctions } from '@cloudbase/functions'
import { registerStorage } from '@cloudbase/storage'
import { registerRealtime } from '@cloudbase/realtime'
import { registerModel } from '@cloudbase/model'
import { registerAi } from '@cloudbase/ai'
import { registerCloudrun } from '@cloudbase/cloudrun'
import { registerMySQL } from '@cloudbase/mysql'
import { registerApis } from '@cloudbase/apis'
// @ts-ignore
import { registerDatabase } from '../database/src/index'
import { ICloudbase } from '@cloudbase/types'

// __SDK_VERSION__ will be replaced at build time
declare const __SDK_VERSION__: string
const version: string = __SDK_VERSION__
cloudbase.registerVersion(version)

// Node 环境下加载 Node adapter
try {
  // eslint-disable-next-line @typescript-eslint/no-var-requires, @typescript-eslint/no-require-imports
  const { getSdkVersion } = require('@cloudbase/app/src/constants/common')
  // eslint-disable-next-line @typescript-eslint/no-var-requires, @typescript-eslint/no-require-imports
  const nodeAdapter = require('@cloudbase/app/src/libs/adapter-node')

  cloudbase.useAdapters(nodeAdapter.default)

  // 将 node-sdk 常用的静态属性/方法挂到 cloudbase 实例上
  const cb = cloudbase as any
  cb.version = getSdkVersion()
  cb.SYMBOL_CURRENT_ENV = nodeAdapter.SYMBOL_CURRENT_ENV
  cb.SYMBOL_DEFAULT_ENV = nodeAdapter.SYMBOL_DEFAULT_ENV
  cb.parseContext = nodeAdapter.parseContext
  cb.getCloudbaseContext = nodeAdapter.getCloudbaseContext
} catch (error) {
  // Node adapter 加载失败时静默处理
}

// 注册所有子模块
try {
  registerAuth(cloudbase)
  registerFunctions(cloudbase)
  registerStorage(cloudbase)
  registerDatabase(cloudbase)
  registerRealtime(cloudbase)
  registerModel(cloudbase)
  registerAi(cloudbase)
  registerCloudrun(cloudbase)
  registerMySQL(cloudbase)
  registerApis(cloudbase)
} catch (e) {}

declare global {
  interface Window {
    cloudbase: ICloudbase
  }
}
try {
  (window as Window).cloudbase = cloudbase
} catch (e) {}
// @ts-ignore
export = cloudbase
export default cloudbase
